import type { Category } from "@/services/collection/categories/categoriesTypes";
import { CategoryId } from "@/services/collection/categories/categoriesSchema";
import type { MaybeRef } from "vue";
import { unref } from "vue";

export function useCategory(category: MaybeRef<Category | undefined>) {
  const categoryId = computed(() => {
    const c = unref(category);
    if (c === undefined) {
      return undefined; // Category not loaded yet
    } else {
      return c.id;
    }
  });

  const showConditionHelpLink = computed(() => {
    const supportedCategoryIds = [CategoryId.SportsCards, CategoryId.Pokemon];
    if (categoryId.value !== undefined && supportedCategoryIds.includes(categoryId.value)) {
      return true;
    } else {
      return false;
    }
  });

  return {
    showConditionHelpLink,
  };
}
